import { useCallback } from 'react';

import { IButtonToggleOption } from './types';

function ButtonToggleOption({
  onSelect,
  value,
  children,
  textColor = 'var(--x-accent-2-1)',
}: IButtonToggleOption) {
  const handleSelect = useCallback(() => {
    onSelect?.(value);
  }, [onSelect, value]);

  return (
    <button type="button" style={{ color: textColor }} onClick={handleSelect}>
      {children}
    </button>
  );
}

export default ButtonToggleOption;
